import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_BLOG_CATEGORIES,
  SG_GET_BLOG_CATEGORIES,
  DELETE_BLOG_CATEGORY,
  SG_DELETE_BLOG_CATEGORY,
  FETCH_BLOG_CATEGORY,
  SG_FETCH_BLOG_CATEGORY,
  EDIT_BLOG_CATEGORY,
  SG_EDIT_BLOG_CATEGORY,
  ADD_BLOG_CATEGORY,
  SG_ADD_BLOG_CATEGORY,
  CLEAR_BLOG_CATEGORY,
    ALL_ERRORS,
} from "constants/actions";



function* loadblogs(action) {
//   yield put({ type: GET_blog_CATEGORIES_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_BLOG_CATEGORIES, action.payload);
    yield put({ type: GET_BLOG_CATEGORIES, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e.response });
  }
}

export function* blogLoad() {
  yield takeLatest(SG_GET_BLOG_CATEGORIES, loadblogs);
}

function* fetchblogs(action) {
  try {
    const json = yield call(api.FETCH_BLOG_CATEGORY, action.payload);
    yield put({ type: FETCH_BLOG_CATEGORY, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e.response });
  }
}

export function* blogFetch() {
  yield takeLatest(SG_FETCH_BLOG_CATEGORY, fetchblogs);
}

function* updateblogs(action) {
  try {
    const json = yield call(api.EDIT_BLOG_CATEGORY, action.payload);
    yield put({ type: EDIT_BLOG_CATEGORY, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e.response });
  }
}

export function* blogUpdate() {
  yield takeLatest(SG_EDIT_BLOG_CATEGORY, updateblogs);
}

function* addblogs(action) {
  try {
    const json = yield call(api.ADD_BLOG_CATEGORY, action.payload);
    yield put({ type: ADD_BLOG_CATEGORY, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e.response });
  }
}

export function* blogAdd() {
  yield takeLatest(SG_ADD_BLOG_CATEGORY, addblogs);
}


function* deleteblogs(action) {
  try {
    const json = yield call(api.DELETE_BLOG_CATEGORY, action.payload);
    yield put({ type: DELETE_BLOG_CATEGORY, payload: json.data });

  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e.response });
  }
}

export function* blogDelete() {
  yield takeLatest(SG_DELETE_BLOG_CATEGORY, deleteblogs);
}


export default function* index() {
  yield all([
    blogLoad(),
    blogFetch(),
    blogUpdate(),
    blogAdd(),
    blogDelete(),
  ]);
}
